"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  // SUBSCRIPTIONS
  REQUEST_SUBSCRIPTION_STATUS: null,
  RECEIVE_SUBSCRIPTION_STATUS: null,
  ERROR_SUBSCRIPTION_STATUS: null,
  REQUEST_SUBSCRIPTIONS_BY_FORM_GUID: null,
  RECEIVE_SUBSCRIPTIONS_BY_FORM_GUID: null,
  ERROR_SUBSCRIPTIONS_BY_FORM_GUID: null,
  CHANGE_SUBSCRIPTION_STATUS: null,
  SAVE_SUBSCRIPTIONS: null,
  SAVE_SUBSCRIPTIONS_SUCCESS: null,
  SAVE_SUBSCRIPTIONS_ERROR: null,
  RESET_SUBSCRIPTIONS: null,
  REQUEST_SUBSCRIPTIONS_DEFINITIONS: null,
  RECEIVE_SUBSCRIPTIONS_DEFINITIONS: null,
  ERROR_SUBSCRIPTIONS_DEFINITIONS: null,
  // SETTINGS
  REQUEST_SETTINGS: null,
  RECEIVE_SETTINGS: null,
  ERROR_SETTINGS: null,
  SUBMIT_SETTINGS_FORM: null,
  SUCCESS_SETTINGS_FORM: null,
  ERROR_SETTINGS_FORM: null,
  SUCCESS_REMOVE_LAST_EMAIL_SYNC_ERROR: null,
  ERROR_REMOVE_LAST_EMAIL_SYNC_ERROR: null,
  ERROR_REDIRECT_OAUTH_PROVIDER: null,
  SAVED_CHANGES: null,
  UNSAVED_CHANGES: null,
  UPDATE_SETTINGS_TEMPORAL: null,
  RESTORE_SETTINGS_TEMPORAL: null,
  DISMISS_SCRIPTLOADER_BANNER: null,
  // DYNOS
  REQUEST_DYNOS: null,
  RECEIVE_DYNOS: null,
  ERROR_DYNOS: null,
  UPDATE_DYNOS_TABLE_SORTING: null,
  UPDATE_DYNOS_TABLE_SEARCH: null,
  REQUEST_DYNOS_ANALYTICS: null,
  RECEIVE_DYNOS_ANALYTICS: null,
  ERROR_DYNOS_ANALYTICS: null,
  REQUEST_DYNO_ENABLE_SWITCH: null,
  RECEIVE_DYNO_ENABLE_SWITCH: null,
  ERROR_DYNO_ENABLE_SWITCH: null,
  REMOVE_ERROR_DYNO_ENABLED_SWITCH: null,
  REQUEST_DYNO_BY_ID: null,
  RECEIVE_DYNO_BY_ID: null,
  ERROR_DYNO_BY_ID: null,
  REQUEST_DYNO_DELETE: null,
  RECEIVE_DYNO_DELETE: null,
  ERROR_DYNO_DELETE: null,
  REMOVE_ERROR_DYNO_DELETE: null,
  REQUEST_DYNO_CLONE: null,
  RECEIVE_DYNO_CLONE: null,
  ERROR_DYNO_CLONE: null,
  REMOVE_ERROR_DYNO_CLONE: null,
  REQUEST_DYNO_REVISIONS: null,
  RECEIVE_DYNO_REVISIONS: null,
  ERROR_DYNO_REVISIONS: null,
  // DYNOS EDITOR
  REQUEST_DYNO_FOR_EDITOR: null,
  RECIEVE_DYNO_FOR_EDITOR: null,
  ERROR_DYNO_FOR_EDITOR: null,
  UPLOAD_DYNO_IMAGE_SUCCESS: null,
  REMOVE_UPLOAD_DYNO_IMAGE: null,
  ADD_VALIDATION_ERROR: null,
  REMOVE_VALIDATION_ERROR: null,
  RESET_VALIDATION_ERRORS: null,
  AUTO_SAVE_DYNO: null,
  CANCEL_AUTO_SAVE_DYNO: null,
  SAVE_DYNO: null,
  REQUEST_DYNO_CREATION: null,
  CREATE_DYNO_SUCCESS: null,
  REPORT_DYNO_CREATION_ERROR: null,
  CLEAR_DYNO_CREATION_ERROR: null,
  SAVE_DYNO_SUCCESS: null,
  SAVE_DYNO_ERROR: null,
  SET_EDITOR_STEP: null,
  SET_EDITOR_DYNO_ID: null,
  UPDATE_EDITABLE_DYNO: null,
  CLEAR_EDITABLE_DYNO: null,
  FETCH_DYNO_BY_GUID: null,
  FAILED_TO_GET_DYNO_BY_GUID: null,
  SAVE_DRAFT: null,
  SAVE_DRAFT_SUCCESS: null,
  SAVE_DRAFT_ERROR: null,
  SAVE_DRAFT_NO_CHANGES: null,
  DELETE_DRAFT: null,
  DELETE_DRAFT_SUCCESS: null,
  DELETE_DRAFT_ERROR: null,
  RECEIVE_KICKBACK_PREVIEWS: null,
  REQUEST_KICKBACKS: null,
  ERROR_KICKBACKS: null,
  // DYNO FORM
  ADD_FORM_FIELD: null,
  SET_FORM_FIELDS: null,
  // DYNO AUDIENCE
  SET_AUDIENCE: null,
  ADD_AUDIENCE_FILTER: null,
  REMOVE_AUDIENCE_FILTER: null,
  UPDATE_AUDIENCE_FILTER: null,
  ADD_AUDIENCE_GROUP: null,
  REMOVE_AUDIENCE_GROUP: null,
  UPDATE_AUDIENCE_GROUP: null,
  REMOVE_INITIAL_FILTER: null,
  ADD_INITIAL_FILTER: null,
  ADD_HIDE_AUDIENCE: null,
  // DYNO DETAILS
  REQUEST_DYNO_FOR_OVERVIEW: null,
  RECEIVE_DYNO_FOR_OVERVIEW: null,
  ERROR_DYNO_FOR_OVERVIEW: null,
  REQUEST_DYNO_OVERVIEW_ANALYTICS: null,
  RECEIVE_DYNO_OVERVIEW_ANALYTICS: null,
  ERROR_DYNO_OVERVIEW_ANALYTICS: null,
  // CAN SPAM SETTINGS
  REQUEST_CAN_SPAM_SETTINGS_FOR_EDITOR: null,
  RECEIVE_CAN_SPAM_SETTINGS_FOR_EDITOR: null,
  REMOVE_CAN_SPAM_SETTINGS_SAVE_ERROR: null,
  ERROR_CAN_SPAM_SETTINGS: null,
  UPDATE_EDITABLE_CAN_SPAM_SETTINGS: null,
  SAVE_CAN_SPAM_SETTINGS: null,
  SAVE_CAN_SPAM_SETTINGS_SUCCESS: null,
  SAVE_CAN_SPAM_SETTINGS_ERROR: null,
  // DOUBLE OPT IN SETTINGS
  REQUEST_DOUBLE_OPT_IN_SETTINGS: null,
  RECEIVE_DOUBLE_OPT_IN_SETTINGS: null,
  REMOVE_DOUBLE_OPT_IN_SETTINGS_SAVE_ERROR: null,
  REMOVE_DOUBLE_OPTIN_SETTINGS_LOADING_ERROR: null,
  ERROR_LOAD_DOUBLE_OPT_IN_SETTINGS: null,
  UPDATE_DOUBLE_OPT_IN_SETTINGS: null,
  SAVE_DOUBLE_OPT_IN_SETTINGS: null,
  SAVE_DOUBLE_OPT_IN_SETTINGS_SUCCESS: null,
  SAVE_DOUBLE_OPT_IN_SETTINGS_ERROR: null,
  // USERS
  REQUEST_USERS: null,
  RECEIVE_USERS: null,
  ERROR_RETRIEVING_USERS: null,
  REMOVE_USERS_LOADING_ERROR: null,
  CLOSE_EMAIL_VERIFICATION_WARNING: null,
  REQUEST_EMAIL_SUBSCRIPTIONS: null,
  RECEIVE_EMAIL_SUBSCRIPTIONS: null,
  ERROR_RETRIEVING_EMAIL_SUBSCRIPTIONS: null,
  REMOVE_EMAIL_SUBSCRIPTIONS_LOADING_ERROR: null,
  // TEAMS
  REQUEST_TEAMS: null,
  RECEIVE_TEAMS: null,
  ERROR_RETRIEVING_TEAMS: null,
  REMOVE_TEAMS_LOADING_ERROR: null,
  // GATES
  SET_GATES: null,
  // Scopes
  SET_SCOPES: null,
  // User
  SET_USER: null,
  // Portal
  SET_PORTAL: null,
  // Contact properties
  REQUEST_CONTACT_PROPERTIES: null,
  RECEIVE_CONTACT_PROPERTIES: null,
  HANDLE_CONTACT_PROPERTIES_FETCH_ERROR: null,
  REQUEST_CONTACT_PROPERTY_CREATION: null,
  HANDLE_PROPERTY_CREATION_SUCCESS: null,
  HANDLE_PROPERTY_CREATION_ERROR: null,
  // Legal Consent Settings
  RECEIVE_LEGAL_CONSENT_SETTINGS: null,
  ERROR_LEGAL_CONSENT_SETTINGS: null,
  // HUB SETTINGS
  REQUEST_HUB_SETTINGS: null,
  REQUEST_HUB_SETTINGS_SUCCESS: null,
  REQUEST_HUB_SETTINGS_ERROR: null,
  UPDATE_HUB_SETTINGS: null,
  UPDATE_HUB_SETTINGS_SUCCESS: null,
  UPDATE_HUB_SETTINGS_ERROR: null
});

exports.default = _default;
module.exports = exports.default;